






































import Vue from 'vue'
import analytics from '~/mixins/analytics'
import Dashboard from '~/components/analytics/CustomerRetention/Dashboard.vue'

export default Vue.extend({
  name: 'CustomerRetentionPage',
  components: {
    Dashboard,
  },
  mixins: [analytics],
  middleware: 'account_check',
  head() {
    return {
      title: `Customer Retention - ${this.currentProfileName} | ${this.currentProfile?.country}`,
    }
  },
})
